import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IClientsService } from "services/ClientsService";
import { ClientSelectRequestModel, GuidSelectModel } from "services/api/cplapi/CPLAPI";
import { RootState } from "setup";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";

const initialState = {
  ClientSelectModels: new Array<GuidSelectModel>(),
  Loading: false,
  LastUpdateTime: new Date(),
};

export const clientSelectSlice = createSlice({
  name: "clientSelect",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getClientSelectModels.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getClientSelectModels.rejected, (state) => {
        state.Loading = false;
      })
      .addCase(getClientSelectModels.fulfilled, (state, action) => {
        state.ClientSelectModels = action.payload;
        state.Loading = false;
        state.LastUpdateTime = new Date();
      });
  },
});

export const getClientSelectModels = createAsyncThunk(
  "Clients/GetSelectModels",
  async (payload?: ClientSelectRequestModel) => {
    const clientsService = container.get<IClientsService>(SERVICE_TYPES.ClientsService);
    return await clientsService.getSelectModels(payload);
  }
);

export const selectClientSelectModels = (state: RootState) => {
  return state.clientSelect.ClientSelectModels;
};
export const selectLoading = (state: RootState) => {
  return state.clientSelect.Loading;
};
export const selectLastUpdateTime = (state: RootState) => {
  return state.clientSelect.LastUpdateTime;
};

export default clientSelectSlice.reducer;
